import { Container, Typography } from '@mui/material';
import { ProductListFragment } from 'modules/Admin/Products/Fragments/ProductList';
import React from 'react';
import { UIBreadcrumb, UILink } from 'shared/components';

export function ProductsPage() {
  return (
    <Container maxWidth={'lg'}>
      <UIBreadcrumb>
        <UILink to={'/dashboard'}> Dashboard </UILink>
        <Typography color={'primary'}> Produtos </Typography>
      </UIBreadcrumb>
      <ProductListFragment />
    </Container>
  );
}
